import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation } from "@tanstack/react-query";
import getSiteFileUploadUrl from "../http/getSiteFileUploadUrl";
import putSiteFile from "../http/putSiteFile";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UploadPayload {
  file: File;
  siteFile: {
    fileType: string;
    fileGuid: string | null;
    fileName?: string;
  };
}

const useSiteFileUpload = (siteId: string) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const uploadSiteFile = useMutation(
    async ({ file, siteFile }: UploadPayload) => {
      const { name, type: contentType } = file;
      const fetchSiteFileUploadUrl = await getSiteFileUploadUrl(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        siteFile.fileType,
        contentType,
        siteFile.fileGuid,
        name
      );
      const siteFileUploadUrl = fetchSiteFileUploadUrl.url;
      await putSiteFile(siteFileUploadUrl, contentType, file);
      return {
        fileType: siteFile.fileType,
        fileGuid: fetchSiteFileUploadUrl.fileGuid,
        fileName: siteFile.fileName || name,
      };
    }
  );

  return {
    uploadSiteFile,
  };
};

export default useSiteFileUpload;
